import React, { useEffect, useState } from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { DIR_RTL } from "../../../constants/ThemeConstant";
import { useSelector } from "react-redux";
import { RightOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import "./style.css";
import { ApartmentIcon, DeliveryInformationIcon, HouseIcon, OfficeIcon } from "assets/svg/icon";
import { Button } from "antd";



function CheckOutTwo() {
    const { theme: { direction, locale }, cartData: { cartQuantity } } = useSelector(state => state);
    const [values, setValues] = useState({});
    const [checkValue, setCheckValue] = useState(false);
    const [selectChose, setSelectChose] = useState('home');
    const history = useHistory();

    const handleValue = (e) => {
        setValues(prev => ({ ...prev, [e.target.name]: e.target.value }));
    }

    const handleSelectChose = (key) => {
        setSelectChose(key);
        // setValues({ houseNo: "", building: "", floor: "", officeNo: "", apartmentNo: ""});
    }

    useEffect(()=>{
        if (localStorage.getItem('deliveryInfo')!==null){
            const deliveryInfo = JSON.parse(localStorage.getItem('deliveryInfo'))
            setSelectChose(deliveryInfo?.unitType)
            setValues(deliveryInfo)
        }
    }, [])

    const setDeliveryInfo = () => {
        switch (selectChose)  {
            case 'home':
                localStorage.setItem('deliveryInfo', JSON.stringify({
                    unitType: selectChose, block: values?.block, street: values?.street, avenue: values?.avenue, special: values?.special, house: values?.house
                }))
                break;
            case 'office':
                localStorage.setItem('deliveryInfo', JSON.stringify({
                    unitType: selectChose,
                    block: values?.block, street: values?.street, avenue: values?.avenue, special: values?.special, building: values?.building, floor: values?.floor, officeNo: values?.officeNo
                }))
                break;
            case 'apartment':
                localStorage.setItem('deliveryInfo', JSON.stringify({
                    unitType: selectChose,
                    block: values?.block, street: values?.street, avenue: values?.avenue, special: values?.special, building: values?.building, floor: values?.floor, apartmentNo: values?.apartmentNo
                }))
                break;
            default:
                break;
        }
    }

    const onFinish = () => {
        setCheckValue(true);
        localStorage.removeItem('deliveryInfo');
        switch (selectChose) {
            case 'home':
                if (values.block && values.street && values.house) {
                    setDeliveryInfo();
                    history.push('checkOutThree');
                }
                break;
            case 'office':
                if (values.block && values.street && values.building && values.floor && values.officeNo) {
                    setDeliveryInfo();
                    history.push('checkOutThree');
                }
                break;
            case 'apartment':
                if (values.block && values.street && values.building && values.floor && values.apartmentNo) {
                    setDeliveryInfo();
                    history.push('checkOutThree');
                }
                break;
            default:
                break;
        }
    }

    return (
        <div className="checkOut-page-style">
            <div className="checkOutNav">
                <div onClick={() => window.history.back()}>
                    <ArrowLeftOutlined rotate={direction === DIR_RTL ? 180 : 0} style={{ fontSize: '24px', cursor: 'pointer', color: 'black' }} />
                </div>
                <div className='text-center w-100' style={{ fontSize: "17px", color: '#000', fontWeight: '600' }}>Checkout</div>
            </div>
            <div className="checkout-status">
                <span style={{backgroundColor: "var(--primaryColor)"}}/>
                <span style={{backgroundColor: "var(--primaryColor)"}}/>
                <span style={{backgroundColor: "grey" }}/>
                <span style={{backgroundColor: "grey" }}/>
            </div>
            <div className="checkOut-content">
                <div className={"text-center"}>
                    {DeliveryInformationIcon('mt-4', "var(--primaryColor)")}
                    <h2 className={'mt-2'}> Delivery information </h2>
                </div>
                <div className={'checkOut-form mt-5'}>
                    <div className='d-flex justify-content-between align-items-center mb-3'>
                        <h4> Area </h4>
                        <RightOutlined onClick={() => history.push('order-mode?mode=delivery')} style={{color: "var(--primaryColor)", fontSize: "22px"}}/>
                    </div>
                    <p style={{ fontSize: "16px" }}>Choose Unit type</p>
                    <div className="choseUnitType">
                        <div className={`${selectChose === 'home' ? 'select-chose' : ''} choseUnitType-item`} onClick={() => handleSelectChose('home')}>
                            {HouseIcon('MuiSvgIcon-root houseIcon', selectChose === 'home' ? 'var(--primaryColor)' : 'grey')}
                            <span> House </span>
                        </div>
                        <div className={`${selectChose === 'office' ? 'select-chose' : ''} choseUnitType-item`} onClick={() => handleSelectChose('office')}>
                            {OfficeIcon('MuiSvgIcon-root houseIcon', selectChose === 'office' ? 'var(--primaryColor)' : 'grey')}
                            <span> Office </span>
                        </div>
                        <div className={`${selectChose === 'apartment' ? 'select-chose' : ''} choseUnitType-item`} onClick={() => handleSelectChose('apartment')}>
                            {ApartmentIcon('MuiSvgIcon-root houseIcon', selectChose === 'apartment' ? 'var(--primaryColor)' : 'grey')}
                            <span> Apartment </span>
                        </div>
                    </div>
                    <div className={'checkOut-form-item'}>
                        <input type="text" name="block" onChange={handleValue} value={values?.block || ''}/>
                        <label className='labelName'>
                            <span className={`${values?.block || checkValue ? "select-content-name" : ""} content-name`}> Block</span>
                        </label>
                        <span className={`${checkValue ? (values?.block ? "d-none" : "") : "d-none"} checkOut-form-error`}> Please enter your Block! </span>
                    </div>
                    <div className={'checkOut-form-item'}>
                        <input type="text" name="street" onChange={handleValue} value={values?.street || ''}/>
                        <label className='labelName'>
                            <span className={`${values?.street || checkValue ? "select-content-name" : ""} content-name`}> Street</span>
                        </label>
                        <span className={`${checkValue ? (values?.street ? "d-none" : "") : "d-none"} checkOut-form-error`}> Please enter your Street! </span>
                    </div>
                    <div className={'checkOut-form-item'}>
                        <input type="text" name="avenue" onChange={handleValue} value={values?.avenue || ''}/>
                        <label className='labelName'>
                            <span className={`${values?.avenue ? "select-content-name" : ""} content-name`}> Avenue (Optional) </span>
                        </label>
                    </div>
                    {selectChose === 'office' ?
                        <>
                            <div className={'checkOut-form-item'}>
                                <input type="text" name="building" onChange={handleValue} value={values?.building || ''}/>
                                <label className='labelName'>
                                    <span className={`${values?.building || checkValue ? "select-content-name" : ""} content-name`}> Building </span>
                                </label>
                                <span className={`${checkValue ? (values?.building ? "d-none" : "") : "d-none"} checkOut-form-error`}> Please enter your Building! </span>
                            </div>
                            <div className={'checkOut-form-item'}>
                                <input type="text" name="floor" onChange={handleValue} value={values?.floor || ''}/>
                                <label className='labelName'>
                                    <span className={`${values?.floor || checkValue ? "select-content-name" : ""} content-name`}> Floor </span>
                                </label>
                                <span className={`${checkValue ? (values?.floor ? "d-none" : "") : "d-none"} checkOut-form-error`}> Please enter your Floor! </span>
                            </div>
                            <div className={'checkOut-form-item'}>
                                <input type="text" name="officeNo" onChange={handleValue} value={values?.officeNo || ''}/>
                                <label className='labelName'>
                                    <span className={`${values?.officeNo || checkValue ? "select-content-name" : ""} content-name`}> Office No. </span>
                                </label>
                                <span className={`${checkValue ? (values?.officeNo ? "d-none" : "") : "d-none"} checkOut-form-error`}> Please enter your Office No! </span>
                            </div>
                        </> : selectChose === 'apartment' ?
                            <>
                                <div className={'checkOut-form-item'}>
                                    <input type="text" name="building" onChange={handleValue} value={values?.building || ''}/>
                                    <label className='labelName'>
                                        <span className={`${values?.building || checkValue ? "select-content-name" : ""} content-name`}> Building </span>
                                    </label>
                                    <span className={`${checkValue ? (values?.building ? "d-none" : "") : "d-none"} checkOut-form-error`}> Please enter your Building! </span>
                                </div>
                                <div className={'checkOut-form-item'}>
                                    <input type="text" name="floor" onChange={handleValue} value={values?.floor || ''}/>
                                    <label className='labelName'>
                                        <span className={`${values?.floor || checkValue ? "select-content-name" : ""} content-name`}> Floor </span>
                                    </label>
                                    <span className={`${checkValue ? (values?.floor ? "d-none" : "") : "d-none"} checkOut-form-error`}> Please enter your Floor! </span>
                                </div>
                                <div className={'checkOut-form-item'}>
                                    <input type="text" name="apartmentNo" onChange={handleValue} value={values?.apartmentNo || ''}/>
                                    <label className='labelName'>
                                        <span className={`${values?.apartmentNo || checkValue ? "select-content-name" : ""} content-name`}> Apartment No! </span>
                                    </label>
                                    <span className={`${checkValue ? (values?.apartmentNo ? "d-none" : "") : "d-none"} checkOut-form-error`}> Please enter your Apartment No! </span>
                                </div>
                            </>
                            :
                            <div className={'checkOut-form-item'}>
                                <input type="text" name="house" onChange={handleValue} value={values?.house}/>
                                <label className='labelName'>
                                    <span className={`${values?.house || checkValue ? "select-content-name" : ""} content-name`}> House No </span>
                                </label>
                                <span className={`${checkValue ? (values?.house ? "d-none" : "") : "d-none"} checkOut-form-error`}> Please enter your House No! </span>
                            </div>
                    }

                    <div className={'checkOut-form-item'}>
                        <input type="text" name="special" onChange={handleValue} value={values?.special}/>
                        <label className='labelName'>
                            <span className={`${values?.special  ? "select-content-name" : ""} content-name`}>Special Directions (Optional) </span>
                        </label>
                    </div>
                </div>
            </div>
            <div className='orderCheckoutContainer branch-btn'>
                <Button onClick={onFinish} className={`w-100 orderCheckout btn-project primaryColor`}>
                    Next
                </Button>
            </div>
            {/* <div className="checkOut-finish-btn">
                <button className="primaryColor" onClick={onFinish}> <span> Next </span> </button>
            </div> */}
        </div>
    )
}


export default CheckOutTwo;